import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const ClipboardListSVG = ({
  fill = 'none',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => (
  <span className={`inline-block ${wrapperClass || ''}`}>
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path
        d="M9.99992 1.33337H5.99992C5.63173 1.33337 5.33325 1.63185 5.33325 2.00004V3.33337C5.33325 3.70156 5.63173 4.00004 5.99992 4.00004H9.99992C10.3681 4.00004 10.6666 3.70156 10.6666 3.33337V2.00004C10.6666 1.63185 10.3681 1.33337 9.99992 1.33337Z"
        stroke="#131720"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6667 2.66663H12.0001C12.3537 2.66663 12.6928 2.8071 12.9429 3.05715C13.1929 3.3072 13.3334 3.64634 13.3334 3.99996V13.3333C13.3334 13.6869 13.1929 14.0261 12.9429 14.2761C12.6928 14.5261 12.3537 14.6666 12.0001 14.6666H4.00008C3.64646 14.6666 3.30732 14.5261 3.05727 14.2761C2.80722 14.0261 2.66675 13.6869 2.66675 13.3333V3.99996C2.66675 3.64634 2.80722 3.3072 3.05727 3.05715C3.30732 2.8071 3.64646 2.66663 4.00008 2.66663H5.33341"
        stroke="#131720"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8 7.33337H10.6667" stroke="#131720" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 10.6666H10.6667" stroke="#131720" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M5.33325 7.33337H5.33992"
        stroke="#131720"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33325 10.6666H5.33992"
        stroke="#131720"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </span>
);

export default ClipboardListSVG;
